export function pageTitleForPath(pathname: string) {
  if (pathname === '/') return 'ภาพรวม';
  if (pathname === '/upload') return 'เพิ่มข้อมูล';
  if (pathname === '/review') return 'รายการรอตรวจ';
  if (pathname.startsWith('/review/')) return 'ตรวจและยืนยันสลิป';
  if (pathname === '/transactions') return 'รายการ';
  if (pathname === '/targets') return 'เป้าหมายและแจ้งเตือน';
  if (pathname === '/settings') return 'ตั้งค่า';
  return 'Private Wealth';
}
